module.exports = __webpack_public_path__ + "img/lessthan-blur-gray.73502575.svg";